import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'packagePallets'
})
export class PackagePalletsPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(packageList: any[]): number {
    let totalPallets = 0;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          totalPallets += pkg.items.reduce((acc, item) => {
            if (item.pallets) {
              acc += (item.pallets || 0);
              // acc += (item.pallets * (item.count || 1));
            }
            return acc;
          }, 0);
        }
      });
    }

    totalPallets =  Number.isInteger(totalPallets) ? totalPallets : Number(totalPallets.toFixed(2));
    return this.translateService.instant(totalPallets === 1 ? 'X_PALLET' : 'X_PALLETS', {sum: totalPallets});
  }
}
